import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";
const requireContext = require.context('./modules', false, /.*\.js$/);
const modules = requireContext.keys()
    .map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])
    .reduce((modules, [name, module]) => {
        if (module.namespaced === undefined) {
            module.namespaced = true
        }

        return {
            ...modules,
            [name]: module
        }
    }, {});

export default new Vuex.Store({
    modules,
    plugins: [createPersistedState({
        paths: [
            'auth.token',
            'auth.check',
            'auth.user',
            'auth.codeLoginState',
            'auth.codeChecked',
            'auth.place_by_code_activated',
            'location_selected',
            'lang',
            'order',
            'province.selectProvince',
            'currency',
            'main_location.seletedFilters'
        ]
    })],
})
